import React, { useEffect, useState } from "react";
import ReferralDashboard from "@/components/organisms/referal/referral-dashboard";
import CollapsibleCard from "@/components/atomics/collapsible-card";
import { useOwner } from "@/context/OwnerContext";
import { useWallet } from "@/context/WalletContext";
import { useParams } from "react-router-dom";
import { backend } from "@/services/backend";
import { ProfileExtendedInfo } from "@/services/types";

export default function OwnerReferral() {
  const { address } = useParams();
  const { walletAddress } = useWallet();
  const { isEditView, isOwnerView } = useOwner();
  const [extendInfo, setExtendInfo] = useState<ProfileExtendedInfo | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);

  // Fetch extended profile data to access referral information
  useEffect(() => {
    const fetchExtendedProfile = async () => {
      if (!address) return;

      try {
        setIsLoading(true);
        const profileData = await backend.getUserExtendedProfile(address);
        setExtendInfo(profileData);
      } catch (error) {
        console.error("Error fetching extended profile:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchExtendedProfile();
  }, [address]);

  const referralData = extendInfo?.referral;

  return (
    address === walletAddress && (
      <CollapsibleCard
        editTitle="MY REFERRALS"
        viewTitle="MY REFERRALS"
        className="w-full px-[30px]"
        viewClassName="text-[30px]"
        isEditView={isEditView || isOwnerView}
      >
        <ReferralDashboard
          className="w-full pt-[25px]"
          isEditView={isEditView || isOwnerView}
          walletAddress={walletAddress}
          referralData={referralData}
        />
      </CollapsibleCard>
    )
  );
}
